import { useRequiredContext } from "@redotech/react-util/context";
import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { useMarketingAgentMode } from "@redotech/redo-merchant-marketing-app/marketing-agent/use-marketing-agent-mode";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { matchPath, useLocation } from "react-router-dom";

export const MarketingAgentItems = memo(function MarketingAgentItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const location = useLocation();
  const { mode, shopperAvailable, splitAvailable, loading } =
    useMarketingAgentMode();

  const isEnabled = shopperAvailable || splitAvailable;
  if (!isEnabled || loading) {
    return null;
  }

  const marketingAgentBaseUrl = routes.marketingAgentHref;
  const anyChildSelected = !!matchPath(
    `${marketingAgentBaseUrl}/*`,
    location.pathname,
  );

  if (mode === "off") {
    return (
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.marketingAgentHref }}
        FilledIcon={AiStarIcon}
        friendlyName="Marketing Agent"
        id="marketing-agent"
        UnfilledIcon={AiStarIcon}
      />
    );
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.marketingAgentHref }}
      anyChildSelected={anyChildSelected}
      FilledIcon={AiStarIcon}
      friendlyName="Marketing Agent"
      id="marketing-agent"
      UnfilledIcon={AiStarIcon}
    >
      {mode === "shopper" && (
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: routes.getMarketingAgentSubRoute("playbook"),
          }}
          friendlyName="Playbook"
          id="marketing-agent-playbook"
        />
      )}
      {mode === "split" && (
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: routes.getMarketingAgentSubRoute("dashboard"),
          }}
          friendlyName="Split Test"
          id="marketing-agent-dashboard"
        />
      )}
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getMarketingAgentSubRoute("conversations"),
        }}
        friendlyName="Conversations"
        id="marketing-agent-conversations"
      />
    </RedoSecondaryNavItem>
  );
});
